import { getCurrentRole } from 'containers/User/UserProvider/userStorage.js';
import { STUDENT_ROLE, MODULES_STUDENTPORTFOLIO } from 'containers/User/constants.js';

async function getIndexPath() {
  const role = getCurrentRole();
  return role?.type === STUDENT_ROLE && role?.school.modules.includes(MODULES_STUDENTPORTFOLIO) ? '/portfolio/workspace' : '/home';
}

export default getIndexPath;
